module.exports = __webpack_public_path__ + "static/media/Shielded.81d458c4.svg";